import { allIterationIterface } from 'Interfaces/BDPortalInterfaces/AddNewIterationInterfaces';
import { useEffect, useState } from 'react';
import { bdportalScreenServices } from 'services/bdportalScreenServices';

const SeeMoreIterationLogic = (opportunityID: number) => {
  const [isAllIterationLoading, setIsAllIterationLoading] = useState<boolean>(false);
  const [allIterations, setAllIterations] = useState<allIterationIterface[] | null>(null);

  const getAllIterationsForOpportunity = async (signal?: AbortSignal) => {
    setIsAllIterationLoading(true);
    try {
      const data = await bdportalScreenServices.getAllIterationsForOpportunity(
        opportunityID,
        signal
      );
      data.sort((a, b) => {
        if (a.OpportunityIterationsID > b.OpportunityIterationsID) return -1;
        if (a.OpportunityIterationsID < b.OpportunityIterationsID) return 1;
        return 0;
      });

      setAllIterations(data);
    } catch {
      // Error handled silently - logging omitted
    } finally {
      setIsAllIterationLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    getAllIterationsForOpportunity(signal);

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opportunityID]);

  return { isAllIterationLoading, allIterations };
};

export default SeeMoreIterationLogic;
